import {useState} from "react";
import ButtonsText from "../../../../../../../components/Button/ButtonText";
import CustomDialog from "../../../../../../../components/Dialog/DiaComp";
import {TextDrugRosuvastatin} from "./TextDrugRosuvastatin"


export default function Rosuvastatin() {
    
    const [open, setOpen] = useState(false);
    const handleOpen = () => {setOpen(true);};
    const handleClose = () => {setOpen(false);};

return(
<>      
 
    <ButtonsText onClick={handleOpen} name='Rosuvastatin' size='large' color='common.white'   />
    <CustomDialog open={open} onClose={handleClose}

        title="Rosuvastatin - PGx Recommendation"
        content={ <TextDrugRosuvastatin />}

        />

</>
)}